<template>
    <div class="node-properties-inner">
        <label>From Time</label>
        <input v-model="properties.fromTime">

        <label>To Time</label>
        <input v-model="properties.toTime">

        <label>Days</label>
        <selector :bitmap="true" :options="[
            { value: 0x01, label: 'Su' },
            { value: 0x02, label: 'Mo' },
            { value: 0x04, label: 'Tu' },
            { value: 0x08, label: 'We' },
            { value: 0x10, label: 'Th' },
            { value: 0x20, label: 'Fr' },
            { value: 0x40, label: 'Sa' },
        ]" v-model="properties.days" />
    </div>
</template>

<script>
import Selector from "@/components/nodes/Selector.vue";

export default {
    props: {
        properties: { type: Object, required: true }
    },
    components: { Selector }
}
</script>